import React, { useEffect, useState } from 'react';
// Packages :
import { FaDoorClosed, FaDoorOpen, FaRegSnowflake } from 'react-icons/fa';
import { GiOrange } from 'react-icons/gi';
import { WiHumidity } from 'react-icons/wi';
import { PiFanLight } from 'react-icons/pi';
import Eth from '../../assets/images/eth.png';
// Firebase :
import { onValue } from 'firebase/database';
import { chambersRef } from '../../config/firebaseConfig';

const ChambreDetails = ({ room, name }) => {
    const [chambre, setChambre] = useState([]);

    // ====================== Reel Time Data ======================
    useEffect(() => {
        const unsubscribe = onValue(chambersRef, (snapshot) => {
            const data = snapshot.val();

            if (name === 'chamber1') {
                setChambre(data?.chamber1)
            } else if (name === 'chamber2') {
                setChambre(data?.chamber2)
            } else if (name === 'chamber3') {
                setChambre(data?.chamber3)
            } else if (name === 'chamber4') {
                setChambre(data?.chamber4)
            } else if (name === 'chamber5') {
                setChambre(data?.chamber5)
            } else if (name === 'chamber6') {
                setChambre(data?.chamber6)
            } else if (name === 'chamber7') {
                setChambre(data?.chamber7)
            } else if (name === 'chamber8') {
                setChambre(data?.chamber8)
            } else if (name === 'chamber9') {
                setChambre(data?.chamber9)
            } else if (name === 'chamber10') {
                setChambre(data?.chamber10)
            } else if (name === 'chamber11') {
                setChambre(data?.chamber11)
            }
        });

        // Cleanup function to unsubscribe from the listener when the component unmounts
        return () => unsubscribe();
    }, [name]);

    return (
        <div className='bg-white rounded-md p-2 shadow-md mb-4 w-full'>
            <div className='flex justify-around items-center flex-wrap'>
                {/* Température */}
                <div className="p-2 w-full md:w-full lg:w-1/2 ">
                    <div className='border border-gray rounded-md'>
                        <div className="flex justify-between items-center bg-primary rounded-t-md p-4">
                            <p className='text-xl font-bold text-white'>Température</p>
                            <p className='text-lightgray'>{room?.consignes?.tempconsigne}</p>
                        </div>
                        <p className='text-2xl md:text-4xl font-bold p-4'>{chambre?.data?.temp || '-'} <span className='text-lg lg:text-2xl'>C<sup>o</sup></span></p>
                    </div>
                </div>

                {/* Humidité */}
                <div className="p-2 w-full md:w-full lg:w-1/2">
                    <div className='border border-gray rounded-md'>
                        <div className="flex justify-between items-center bg-primary rounded-t-md p-4">
                            <p className='text-xl font-bold text-white'>Humidité</p>
                            <p className='text-lightgray'>{room?.consignes?.humconsigne}</p>
                        </div>
                        <p className='text-2xl md:text-4xl font-bold p-4'>{chambre?.data?.hum} <span className='text-lg lg:text-2xl'>%</span></p>
                    </div>
                </div>

                {/* CO2 */}
                <div className="p-2 w-full md:w-full lg:w-1/2">
                    <div className='border border-gray rounded-md'>
                        <div className="flex justify-between items-center bg-primary rounded-t-md p-4">
                            <p className='text-xl font-bold text-white'>CO<sub>2</sub></p>
                            <p className='text-lightgray'>{room?.consignes?.co2consigne}</p>
                        </div>
                        <p className='text-2xl md:text-4xl font-bold p-4'>{chambre?.data?.co2} <span className='text-lg lg:text-2xl'>PPM</span></p>
                    </div>
                </div>

                {/* Éthylène */}
                <div className="p-2 w-full md:w-full lg:w-1/2">
                    <div className='border border-gray rounded-md'>
                        <div className="flex justify-between items-center bg-primary rounded-t-md p-4">
                            <p className='text-xl font-bold text-white'>Éthylène</p>
                            <p className='text-lightgray'>{room?.consignes?.ethconsigne}</p>
                        </div>
                        <p className='text-2xl md:text-4xl font-bold p-4'>{chambre?.data?.eth} <span className='text-lg lg:text-2xl'>PPM</span></p>
                    </div>
                </div>
            </div>

            <div className='flex justify-between items-center flex-wrap'>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.mode?.conservsign === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-center items-center h-14 p-2 rounded-md`}>
                        <FaRegSnowflake size={35} color='white' />
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.mode?.deversign === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-center items-center h-14 p-2 rounded-md`}>
                        <GiOrange size={35} color='white' />
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.mode?.Forcage === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-center items-center h-14 p-2 rounded-md`}>
                        <p className='text-white font-bold text-2xl'>F</p>
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.status?.humsign === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-center items-center h-14 p-2 rounded-md`}>
                        <WiHumidity size={40} color='white' />
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.mode?.faninsign === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-around items-center h-14 p-2 rounded-md`}>
                        <PiFanLight size={35} color='white' />
                        <p className='text-white text-sm'>IN</p>
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.mode?.fanoutsign === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-around items-center h-14 p-2 rounded-md`}>
                        <PiFanLight size={35} color='white' />
                        <p className='text-white text-xs'>OUT</p>
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.status?.doorsign === 'on' ? 'bg-primary' : 'bg-lightgray'} flex justify-center items-center bg-lightgray h-14 p-2 rounded-md`}>
                        {chambre?.status?.doorsign === "on" ? (
                            <FaDoorOpen color='white' size={35} />
                        ) : (
                            <FaDoorClosed color='white' size={35} />
                        )}
                    </div>
                </div>
                <div className="p-1 w-1/2 md:w-1/4 lg:w-[12.5%]">
                    <div className={`${chambre?.mode?.ethsign === 'on' ? 'bg-primary' : 'bg-lightgray'} bg-lightgray h-14 p-2 rounded-md flex items-center justify-center`}>
                        <img src={Eth} alt="Éthylène" width={35} />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ChambreDetails;